import reducer from './reducer'

import * as paymentsOperations from './operations'
import * as paymentsSelectors from './selectors'

export { paymentsOperations, paymentsSelectors }

export default reducer
